import { CircleHelp, Gamepad2, UserRound, Wallet, type LucideIcon } from 'lucide-react';

/**
 * The four tabs (spec §3), shared by the header's top tabs (wide layouts) and BottomNav (compact).
 * Money and Me need a signed-in player (requireAuth); Play and Help are open to guests.
 */
export type TabId = 'play' | 'money' | 'help' | 'me';

export interface NavTab {
  id: TabId;
  to: string;
  /** Guests are asked to sign in first (AuthModalContext.requireAuth). */
  gated: boolean;
  /** i18n key of the tab label. */
  labelKey: string;
  /** Tour target on both the top tab and the bottom tab. */
  tourId: string;
}

export const TABS: readonly NavTab[] = [
  { id: 'play', to: '/', gated: false, labelKey: 'header.tabs.play', tourId: 'nav.play' },
  { id: 'money', to: '/money', gated: true, labelKey: 'header.tabs.money', tourId: 'nav.money' },
  { id: 'help', to: '/help', gated: false, labelKey: 'header.tabs.help', tourId: 'nav.help' },
  { id: 'me', to: '/me', gated: true, labelKey: 'header.tabs.me', tourId: 'nav.me' },
];

/** One icon per tab, shared by the header's top tabs and BottomNav so the two always match. */
export const TAB_ICONS: Record<TabId, LucideIcon> = { play: Gamepad2, money: Wallet, help: CircleHelp, me: UserRound };

function isWithin(pathname: string, base: string): boolean {
  return pathname === base || pathname.startsWith(`${base}/`);
}

/**
 * The tab a path belongs to. The detailed money tools that kept their URLs (deposit wizard,
 * wallet top-up, payout request, checkouts) sit under Money's "More options", so they are Money.
 */
export function activeTab(pathname: string): TabId {
  if (isWithin(pathname, '/money') || isWithin(pathname, '/account/finance') || isWithin(pathname, '/account/wallet')) {
    return 'money';
  }
  if (isWithin(pathname, '/help')) return 'help';
  if (isWithin(pathname, '/me')) return 'me';
  return 'play';
}
